// extracted by mini-css-extract-plugin
module.exports = {"description":"dining-module--description--1hC5d"};